<template>
  <v-card class="pa-2">
    <v-row dense class="ma-0 d-flex justify-end">
      <v-btn
        depressed
        color="#0f3565"
        dark
        class="mr-0 hidden-sm-and-down primary-button"
        @click="filtersVisible = !filtersVisible"
      >
        Filtros
      </v-btn>
    </v-row>
    <v-expand-transition>
      <div v-if="filtersVisible">
        <v-row class="ma-0" align="center">
          <v-col>
            <v-text-field
              v-model="filter.identification"
              class="primary-input"
              style="max-width: 270px"
              outlined
              hide-details
              placeholder="Pesquisar por identificação"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              v-model="filter.name"
              class="primary-input"
              style="max-width: 270px"
              outlined
              hide-details
              placeholder="Pesquisar por nome"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              v-model="filter.propertyCode"
              class="primary-input"
              style="max-width: 270px"
              outlined
              hide-details
              placeholder="Pesquisar por patrimônio"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              v-model="filter.serialNumber"
              class="primary-input"
              style="max-width: 270px"
              outlined
              hide-details
              placeholder="Pesquisar por número de série"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-btn class="primary-button ma-1 mb-4" depressed @click="list">
              Filtrar
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </v-expand-transition>

    <v-expand-transition>
      <div class="d-flex justify-end" v-if="downloadList.length > 0">
        <v-btn depressed class="secondary-button" @click="getZip">
          Baixar arquivos ({{ downloadList.length }} selecionados)
        </v-btn>
      </div>
    </v-expand-transition>

    <v-data-table
      :loading="loading"
      :loading-text="$t('Carregando...')"
      :no-data-text="$t('Nenhuma arquivo encontrado')"
      :headers="headers"
      :items="files"
      class="main-table"
      hide-default-footer
      :items-per-page="filter.pageSize"
      :header-props="headerProps"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      show-expand
      hide-default-header
    >
      <template #header="{ props, on }">
        <thead>
          <tr>
            <th
              class="text-center"
              v-for="header in props.headers"
              :key="header.value"
            >
              <div>
                <v-hover v-slot="{ hover }">
                  <div>
                    <span>{{ $t(header.text) }}</span>
                    <v-icon
                      v-if="
                        hover &&
                        header.value != 'data-table-select' &&
                        header.value != 'actions' &&
                        header.value != 'checkbox'
                      "
                      color="white"
                      class="mx-2"
                      @click="on.sort(header.value)"
                    >
                      {{
                        props.options.sortBy.includes(header.value)
                          ? `mdi-chevron-down`
                          : `mdi-chevron-up`
                      }}
                    </v-icon>
                  </div>
                </v-hover>
              </div>
            </th>
          </tr>
        </thead>
      </template>

      <template #[`item.checkbox`]="{ item }">
        <div class="d-flex justify-center">
          <v-checkbox
            dense
            v-model="item.selected"
            @click="addAllToDownloadList(item)"
          ></v-checkbox>
        </div>
      </template>

      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <table class="main-table" style="width: 100%">
            <thead>
              <tr>
                <th>
                  <v-icon color="white">mdi-download</v-icon>
                </th>
                <th
                  style="
                    min-width: unset !important;
                    width: unset !important;
                    max-width: unset !important;
                  "
                  class="pa-2"
                >
                  Nome do arquivo
                </th>
                <th class="pa-2">Tipo de arquivo</th>
                <th class="pa-2">Data do Upload</th>
                <th class="pa-2">Ações</th>
              </tr>
            </thead>
            <tr v-for="file in item.uploadDocuments" :key="file.id">
              <td>
                <v-checkbox
                  v-model="file.selected"
                  @click="addToDownloadList(file)"
                ></v-checkbox>
              </td>
              <td
                style="
                  min-width: unset !important;
                  width: unset !important;
                  max-width: unset !important;
                "
                class="text-center"
              >
                {{ file.name }}
              </td>
              <td class="text-center">.{{ file.fileType }}</td>
              <td class="text-center">{{ formatDate(file.uploadDate) }}</td>
              <td class="text-center">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      class="primary-button"
                      tile
                      small
                      depressed
                      @click="getFile(file)"
                    >
                      <v-icon>mdi-open-in-new</v-icon>
                    </v-btn>
                  </template>
                  <span>Abrir documento</span>
                </v-tooltip>
              </td>
            </tr>
          </table>
        </td>
      </template>
    </v-data-table>

    <div class="pagination">
      <div class="item-pagination block-one">
        <v-menu bottom offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="btn"
              depressed
              color="#C0C0C0"
              small
            >
              qtd: {{ pageSize }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(size, i) in sizes"
              :key="i"
              @click="pageSize = size"
            >
              <v-list-item-title>{{ size }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <div class="registros" v-if="totalItensOnPage">
          <span> 1 - {{ totalItensOnPage }} de {{ totalItems }} </span> <br />
        </div>
      </div>

      <div class="item-pagination block-two">
        <v-pagination
          class="pagination-item"
          v-model="page"
          :length="totalPages"
          :total-visible="9"
        ></v-pagination>
      </div>
    </div>
  </v-card>
</template>

<script>
import ApiService from '../../../../services/ApiService'
import moment from 'moment'

export default {
  name: 'repositoryOrders',

  data() {
    return {
      filtersVisible: false,
      page: 1,
      totalPages: null,
      totalItensOnPage: 0,
      totalItems: 0,
      pageSize: 10,
      sizes: [10, 30, 90, 180],
      downloadList: [],
      expanded: [],
      singleExpand: true,
      headers: [
        {
          text: 'Seleção',
          align: 'center',
          value: 'checkbox',
          sortable: false,
          width: 40,
        },
        {
          text: 'Equip. ID',
          align: 'center',
          value: 'identification',
        },
        {
          text: 'Equipamento',
          align: 'center',
          value: 'name',
        },
        {
          text: 'Patrimônio',
          align: 'center',
          value: 'propertyCode',
        },
        {
          text: 'Número de Série',
          align: 'center',
          value: 'serialNumber',
        },
      ],
      apiService: new ApiService(),
      loading: false,
      headerProps: {
        sortByText: 'Ordenar por',
      },
      filter: {
        page: 1,
        pageSize: 10,
      },
      files: [],
    }
  },

  watch: {
    pageSize() {
      this.filter.pageSize = this.pageSize
      this.filter.page = 1
      this.list()
    },

    page() {
      this.filter.page = this.page
      this.list()
    },
  },

  created() {
    this.list()
  },

  methods: {
    getFile(document) {
      if (document.filePath) {
        if (document.filePath.includes('equipacarefix.blob.core')) {
          const url = document.filePath
          window.open(url)
        } else {
          const url =
            process.env.VUE_APP_BASE_URL +
            document.filePath.replace('wwwroot/', '')
          window.open(url)
        }
      } else {
        this.getDocument(document)
      }
    },

    async getDocument(document) {
      await this.apiService
        .get(`uploadDocument/${document.id}`)
        .then((response) => {
          const fileWindow = window.open()
          const url = 'data:application/pdf;base64,' + response.content.filepath

          fileWindow.document.write(
            `<html>
                <title>${document.fileName}.${document.fileType}</title>
                <body style:"overflow: hidden; margin: 0">
                  <object width="100%" width="-webkit-fill-available" height="100%" height="-webkit-fill-available" type="application/pdf" data="${url}"></object>
                </body>
              </html>`
          )
        })
    },

    addToDownloadList(file) {
      if (file.selected) this.downloadList.push(file)
      else this.downloadList = this.downloadList.filter((x) => x.id != file.id)
    },

    formatDate(date) {
      return date ? moment(date).format('DD/MM/yyyy HH:mm') : 'Sem registros'
    },

    async getZip() {
      if (this.downloadList.length > 25) {
        this.$toast.warning('Máximo de 25 arquivos por vez')
        return
      }
      this.$toast(
        `${this.$t('Imprimindo registros')}: ${
          this.downloadList.length
        } ${this.$t('selecionados')}`
      )
      const ids = this.downloadList.map((x) => x.id)

      await this.apiService
        .post(`serviceOrder/files/zip`, { ids })
        .then((response) => {
          var pedfResult = 'data:application/zip;base64,' + response.content
          const link = document.createElement('a')
          link.href = pedfResult
          link.setAttribute('download', `arquivos_em_lote`)
          document.body.appendChild(link)
          link.click()
          this.downloadList = []
        })
    },

    addAllToDownloadList(item) {
      if (item.selected) {
        this.downloadList.push(...item.uploadDocuments)
        item.uploadDocuments = item.uploadDocuments.map((x) => {
          return {
            ...x,
            selected: true,
          }
        })
      } else {
        this.downloadList = this.downloadList.filter(
          (x) => !item.uploadDocuments.map((y) => y.id).includes(x.id)
        )
        item.uploadDocuments = item.uploadDocuments.map((x) => {
          return {
            ...x,
            selected: false,
          }
        })
      }
    },

    list() {
      const institution = localStorage.getItem('institution')
      this.filter.institutionId = institution ? JSON.parse(institution).id : ''
      this.loading = true

      this.apiService
        .post('equipment/files', this.filter)
        .then((response) => {
          this.files = response.content.equipment
          this.totalPages = response.content.pager.totalPages
          this.totalItems = response.content.pager.totalItems
          this.totalItensOnPage = response.content.equipment.length
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style></style>
